import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  padding: ${rem(32)} ${rem(18)} ${rem(12)};
`;

export const TitleWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;
